import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { HttpClientModule } from '@angular/common/http';

//components
import { ShareComponent } from './components/share/share.component';
import { NotFoundComponent } from './components/common/not-found/not-found.component';
import { ConfigService } from './services/config.service';

export function initializeApp(configService: ConfigService) {
  return () => configService.loadConfig().toPromise().then(config => configService.setConfig(config));
}

@NgModule({
  declarations: [
    AppComponent,

    //components
    ShareComponent,
    NotFoundComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    HttpClientModule,
    
  ],
  exports: [
    //components
    ShareComponent,
    NotFoundComponent
  ],
  providers: [
    ConfigService,
    {
        provide: APP_INITIALIZER,
        useFactory: initializeApp,
        deps: [ConfigService],
        multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
